import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const FooterTypographyStyles = styled(UiTypography)`
  font-size: 8px;
`;

export const CompanyDetailsFooterStyles = styled.footer<{
  $extraPadding?: boolean;
  $noHorizontalPadding?: boolean;
}>`
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  padding: 12px
    ${({ $noHorizontalPadding }) => ($noHorizontalPadding ? 0 : 16)}px
    ${({ $extraPadding }) => ($extraPadding ? 16 : 0)}px;
  flex-shrink: 0;
`;
